import React, { useEffect, useState } from 'react';
import { useFeatureFlag } from 'new/hooks/useFeatureFlags';
import { CredentialFilterToggle } from './CredentialFilterToggle';
import { SearchBar } from 'new/elements/flows/SelectConnection/SearchBar';
import { Stack } from 'new/elements/Stack';
import { Categories } from 'new/elements/flows/SelectConnection/Categories';
import { Connections } from 'new/elements/flows/SelectConnection/Connections';
import {
  SelectConnectionProps,
  SelectConnectionProvider,
  useSelectConnection,
} from 'new/elements/flows/SelectConnection/useSelectConnection';
import { ConnectionLoader } from 'new/elements/ConnectionLoader/ConnectionLoader';
import styles from './SelectConnection.module.scss';

export const LocalSelectConnection = (
  props: SelectConnectionProps & { setSearch?: (value: string) => void },
) => {
  const { setSearch } = props;
  const isCredentialFilterEnabled = useFeatureFlag('UI_TEMP_ENABLE_CRED_FILTER');
  const [showOnlyWithCredentials, setShowOnlyWithCredentials] = useState(false);
  useEffect(() => {
    if (!isCredentialFilterEnabled) setShowOnlyWithCredentials(false);
  }, [isCredentialFilterEnabled]);

  const onSearchChange = (e) => {
    const { value } = e.target;
    setSearch(value);
  };

  const { isLoadingVendors } = useSelectConnection();

  return (
    <Stack flex={1} height="100%" position="relative">
      <SearchBar onSearchChange={onSearchChange} isCentered={!isCredentialFilterEnabled}>
        {isCredentialFilterEnabled && (
          <CredentialFilterToggle
            checked={showOnlyWithCredentials}
            onChange={setShowOnlyWithCredentials}
          />
        )}
      </SearchBar>
      <Stack flex={1} direction="row" minHeight={0}>
        <Categories fixedCategory={props.fixedCategory} />
        <Connections
          showOnlyWithCredentials={isCredentialFilterEnabled && showOnlyWithCredentials}
        />
      </Stack>
      {isLoadingVendors && (
        <Stack className={styles.overlayContainer} justifyContent="center" alignItems="center">
          <ConnectionLoader loading message="Loading connectors..." />
        </Stack>
      )}
    </Stack>
  );
};
LocalSelectConnection.displayName = 'LocalSelectConnection';

export const SelectConnection = (props: SelectConnectionProps) => {
  return (
    <SelectConnectionProvider {...props}>
      <LocalSelectConnection {...props} />
    </SelectConnectionProvider>
  );
};
SelectConnection.displayName = 'SelectConnection';
